export const HOME_BANNER_STORAGE_KEY = "trw-home-banner-slides-v1";
export const HOME_BANNER_UPDATED_EVENT = "trw:home-banner-updated";

const DEFAULT_SLIDES = [
  {
    id: "banner-deals-2026",
    image: "/assets/images/home/rethink-ways-best-travel-deals-2026.avif",
    thumb: "/assets/images/home/rethink-ways-best-travel-deals-2026-thumb.avif",
    title: "Best Travel Deals 2026: International Vacation Offers| Travel Rethink Ways",
    tag: "DEALS",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/",
    tagLink: "https://travel.rethinkways.com/international-travel-deals-2026/",
    mobilePosition: "95% center",
    headline: "Top Travel Deals for International Trips 2026",
    mobileHeadline: "Top Travel Deals for International Trips 2026",
    sub: "Smart travel deals that save time, money & effort under the stars.",
    cta: "Grab the Deals",
  },
  {
    id: "banner-maldives-honeymoon",
    image: "/assets/images/home/rethink-ways-maldives-honeymoon-banner.avif",
    thumb: "/assets/images/home/rethink-ways-maldives-honeymoon-banner-thumb-1.avif",
    title: "Maldives Honeymoon Guide: Dreamy Escapes for Every Couple | Travel Rethink Ways",
    tag: "HONEYMOON GLOBAL",
    link: "https://travel.rethinkways.com/maldives-honeymoon/",
    tagLink: "https://travel.rethinkways.com/category/honeymoon-global/",
    mobilePosition: "95% center",
    headline: "The Perfect Maldives Honeymoon Awaits for You",
    mobileHeadline: "The Perfect Maldives Honeymoon Awaits for You",
    sub: "Wake up over the ocean, dine under the stars and unwind together.",
    cta: "Escape to Maldives",
  },
  {
    id: "banner-india-june",
    image: "/assets/images/home/rethink-ways-30-best-places-india.avif",
    thumb: "/assets/images/home/rethink-ways-30-best-places-india-thumb.avif",
    title: "30 Best Places to Visit in June in India 2026 | Travel Rethink Ways",
    tag: "INDIA 2026",
    link: "https://travel.rethinkways.com/30-best-places-to-visit-in-india-in-june/",
    tagLink: "https://travel.rethinkways.com/category/india-2026/",
    mobilePosition: "99% center",
    headline: "June Escapes Across Incredible India",
    mobileHeadline: "June Escapes Across Incredible India",
    sub: "Explore misty hills, monsoon beauty and refreshing escapes.",
    cta: "View All Places",
  },
  {
    id: "banner-india-deals-2026",
    image: "/assets/images/home/rethink-ways-India-travel-deals-2026.avif",
    thumb: "/assets/images/home/rethink-ways-India-travel-deals-2026-thumb.avif",
    title: "India Travel Deals 2026: Top Domestic Vacation Offers| Travel Rethink Ways",
    tag: "DEALS",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/",
    tagLink: "https://travel.rethinkways.com/india-travel-deals-2026/",
    mobilePosition: "95% center",
    headline: "India Getaways with Smart Travel Deals",
    mobileHeadline: "India Getaways with Smart Travel Deals",
    sub: "Get the best value on trips across India without the hassle.",
    cta: "Start Planning",
  },
  {
    id: "banner-thailand-visa-free",
    image: "/assets/images/home/rethink-ways-visa-free-thailand.avif",
    thumb: "/assets/images/home/rethink-ways-visa-free-thailand.avif",
    title: "Visa-Free Thailand for Indians 2026: 60+30 Days Stay, TDAC Guide & Latest Extension",
    tag: "VISA FREE",
    link: "https://travel.rethinkways.com/thailand-visa-free-entry-for-indians-tdac/",
    tagLink: "https://travel.rethinkways.com/category/visa-free/",
    mobilePosition: "95% center",
    headline: "Visa Free Thailand Travel For Indians 2026",
    mobileHeadline: "Visa Free Thailand Travel For Indians 2026",
    sub: "Complete guide to Thailand visa free entry rules and stay details.",
    cta: "Read Full Guide",
  },
];

function safeParse(value, fallback) {
  try {
    const parsed = JSON.parse(value);
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

export function getDefaultHomeBannerSlides() {
  return DEFAULT_SLIDES;
}

export function getStoredHomeBannerSlides() {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(HOME_BANNER_STORAGE_KEY);
  const parsed = raw ? safeParse(raw, []) : [];
  return Array.isArray(parsed) ? parsed : [];
}

export function getHomeBannerSlides({ includeStoredOverrides = true } = {}) {
  const base = getDefaultHomeBannerSlides();
  if (!includeStoredOverrides || typeof window === "undefined") return base;
  const stored = getStoredHomeBannerSlides();
  return stored.length ? stored : base;
}

export function setHomeBannerSlides(nextSlides) {
  if (typeof window === "undefined") return;
  const payload = Array.isArray(nextSlides) ? nextSlides : [];
  window.localStorage.setItem(HOME_BANNER_STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(new Event(HOME_BANNER_UPDATED_EVENT));
}
